import React from "react";
import {withRouter, Link} from 'react-router-dom';
import { css } from "emotion";
import { colors, textSizes } from "../../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TargetingLink = () => {
  return (
    <div className={container}>
      <Link to={`/targeting?lastLocation=${window.location.pathname}`} className="options-container">
        <div className="optionsRow">
          <p>Advanced Display Options</p>
          <FontAwesomeIcon className="icon" icon="chevron-right"/>
        </div>
      </Link>
    </div>
  );
};

export default TargetingLink;

const container = css`
  a {
    text-decoration: none;
  }

  .optionsRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    position: relative;
    
    p {
      font-size: ${textSizes.intermediate};
      color: ${colors.titleColor};
    }
    
    .icon {
      color: ${colors.chevronColor};
    }
  }
`;
